import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Translate, I18n } from 'react-redux-i18n';
import Select from 'react-select';
import { withRouter } from 'react-router';

import { dataActions } from 'app/actions';

class SupportConfiguration extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const editableUser = this.props.users.find(item => `${item.id}` === this.props.match.params.id);
    if (editableUser) {
      const payload = this.props.serviceLocations.map(location => ({ ...location, selected: editableUser.countries.includes(location.value) }));
      this.props.setUserCountries(payload);
    }
  }

  componentWillUnmount() {
    this.props.setUserCountries(this.props.serviceLocations.map(item => ({ ...item, selected: false })));
  }

  handleChange = (data) => {
    const codes = data.map(item => item.value);
    const payload = this.props.serviceLocations.map(location => ({ ...location, selected: codes.includes(location.value) }));

    this.props.setUserCountries(payload);
  };

  render() {
    const { serviceLocations } = this.props;
    const options = serviceLocations.map(({ value, label }) => ({ value, label }));
    const value = serviceLocations.filter(item => item.selected).map(({ value, label }) => ({ value, label }));

    return (
      <div className="card align-self-stretch w-100">
        <div className="card-header">
          <Translate value="enums.step_group.responsible_region" />
        </div>
        <div className="card-body row align-items-end">
          <div className="col-12 mb-2">
            <label key="label" className="small">
              <Translate value="enums.permission.service_location" />
            </label>
            <Select multi options={options} value={value} onChange={this.handleChange} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    serviceLocations: state.data.serviceLocations,
    users: state.data.users,
  };
};

export default compose(connect(mapStateToProps, { setUserCountries: dataActions.setUserCountries }), withRouter)(SupportConfiguration);
